import email from '../assets/email.png';
import email1 from '../assets/email1.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import headerIMG from '../assets/headerIMG.png';

import profile2 from '../assets/profile2.png';
import circle from '../assets/circle.svg';
import logo1 from '../assets/logo1.png';
import tsllogo from '../assets/tsllogo.png';

const images = {
  email,
  email1,
  mobile,
  api,
  css,
  git,
  html,
  headerIMG,
  javascript,
  node,
  react,
  redux,
  sass,
  typescript,
  profile2,
  circle,
  logo1,
  tsllogo
}

export default images